import NewsletterSignup from "@/components/NewsletterSignup";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { ShieldCheck, FileText, Languages, SearchCheck, Sparkles, Eye, Globe } from "lucide-react";

const STEPS = [
  {
    icon: ShieldCheck,
    title: "Verifichiamo la fonte",
    text: "Partiamo da video pubblicati da governi, istituzioni e canali ufficiali. Prima di utilizzarli controlliamo provenienza, contesto e condizioni d'impiego, indicando sempre la fonte originale.",
  },
  {
    icon: FileText,
    title: "Trascriviamo il contenuto pubblicato",
    text: "La trascrizione segue il contenuto originale, rispettandone l'ordine.",
  },
  {
    icon: Languages,
    title: "Traduciamo senza riscrivere",
    text: "Traduciamo in italiano preservando significato, tono e contesto. La traduzione non aggiunge opinioni e non modifica il messaggio originale.",
  },
  {
    icon: SearchCheck,
    title: "Controlliamo ogni passaggio",
    text: "Verifichiamo nomi, date, luoghi, termini tecnici e riferimenti politici. Ogni versione italiana passa attraverso una revisione della traduzione prima della pubblicazione.",
  },
  {
    icon: Sparkles,
    title: "Realizziamo la versione italiana",
    text: "Quando previsto, utilizziamo strumenti di intelligenza artificiale per il doppiaggio e la sincronizzazione. L'intelligenza artificiale serve esclusivamente a rendere comprensibile il discorso in italiano: non inventa né modifica il contenuto.",
  },
  {
    icon: Eye,
    title: "Rendiamo tutto verificabile",
    text: "In ogni pagina trovi il video, la fonte, la data, il luogo, il testo originale, la traduzione italiana e i riferimenti al minuto.",
  },
];

export default function Methodology() {
  return (
    <div>
      <SEO
        title="Metodo e trasparenza"
        description="Come verifichiamo le fonti ufficiali, trascriviamo i discorsi e realizziamo le traduzioni italiane pubblicate su Smart News Italia."
        canonicalPath="/metodologia"
      />
      <PageHero
        crumb="Metodo e trasparenza"
        overline="Metodo e trasparenza"
        title="Dalla fonte ufficiale alla versione italiana"
        subtitle="Il nostro lavoro comprende l'individuazione della fonte, la trascrizione, la traduzione in italiano e il controllo del contenuto prima della pubblicazione."
        icon={Globe}
      />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12">
        <div className="space-y-4 mb-16">
          {STEPS.map((s, i) => (
            <div key={s.title} className="flex gap-5 bg-card border border-border rounded-sm p-6" data-testid={`method-step-${i}`}>
              <div className="h-11 w-11 rounded-sm bg-primary/10 flex items-center justify-center shrink-0">
                <s.icon className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h3 className="font-serif text-xl font-semibold mb-1.5">{s.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{s.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-muted/60 border border-border rounded-sm p-6 mb-16">
          <h3 className="font-serif text-xl font-semibold mb-2">Hai trovato un errore?</h3>
          <p className="text-muted-foreground leading-relaxed">
            Segnalacelo direttamente dalla pagina del discorso. Verifichiamo ogni indicazione e, se
            necessario, correggiamo la traduzione.
          </p>
        </div>

        <NewsletterSignup />
      </div>
    </div>
  );
}
